import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Spin, Select, InputNumber, Divider, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../features/save/saveSlice";
import PhoneInput from "react-phone-input-2";

const CountyGovtAddModal = ({
  isModalOpen,
  handleCancel,
  handleFetch,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { counties } = useSelector((state) => state.fetch);
 
const [countyName , setCountyName] =  useState()
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (data) => {
    data.usrId = prodd?.usrId ? prodd?.usrId : null;
    data.usrCountyName = countyName 
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/cidu/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleFetch();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  return (
    <Modal
      title={`${prodd?.usrId ? "Update a CIDU" : "Register a CIDU"}`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[59.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <Form.Item
          name="usrCountyId"
          className=""
          label={"County"}
          rules={[
            {
              required: true,
              message: "Please select county",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              counties?.length > 0 &&
              counties?.map((item) => ({
                value: item?.countyId,
                label: item?.countyName,
              }))
            }
            onChange={(value) => {
              const selectedItem = counties?.find((item)=>item?.countyId === value);
              setCountyName(selectedItem?.countyName || '');
          }}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>

        <div className="text-[#050505] text-[1rem] font-interSans font-[500] mt-[2.25rem] mb-[1.25rem]">
          Contact Person
        </div>
        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          <Form.Item
            name="fullNames"
            label={"Name"}
            rules={[
              {
                required: true,
                message: "Please add name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="usrNationalId"
            label="ID Number"
            rules={[
              {
                required: true,
                message: "National ID is required",
              },
              {
                validator(_, value) {
                  if (value && value.toString().length < 6) {
                    return Promise.reject(
                      "National ID must be at least 6 characters long"
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber
              min={0}
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
          <Form.Item
            name="phoneNumber"
            label={"Office Phone Number"}
            rules={[
              {
                required: true,
                message: "Please add office phone no",
              },
            ]}
          >
            <PhoneInput
              country="ke"
              onlyCountries={["ke"]}
              countryCodeEditable={false}
              className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
            />
          </Form.Item>
          <Form.Item
            name="email"
            label={"Official Email"}
            rules={[
              {
                required: true,
                message: "Please add official email address",
              },
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input type="email" className="input" />
          </Form.Item>
        </div>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button disabled={saving} key="submit" type="submit" className="cstm-btn-2">
                {saving ? (
                  <Spin />
                ) : prodd?.usrId ? (
                  "Update Info"
                ) : (
                  "Save Info"
                )}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default CountyGovtAddModal;
